import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

const EnquiryEleven = ({ setFieldValue, errors, touched, values }) => {
  const userToken = localStorage.getItem('token');

  
  const [phone, setPhone] = useState("");
  return (
    <>
      <div>
        <div className="account-created-pop">
          <h3>Contact Details</h3>
          <p>How can electricians contact you?</p>
          <Row>
            <Col lg={12} className="mx-auto">
              <Form className="cmn-form-set">

              <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Name</Form.Label>
                  <Form.Control type="text"
                    placeholder="Type here"
                    name="name"
                    disabled={userToken}
                    value={values.name}
                    // onChange={(e) => setFieldValue("name", e.target.value)}
                    onChange={(e) => {
                      let value = e.target.value.replace(/^\s+/, ""); // Remove leading spaces
                      value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                      setFieldValue("name", value);
                    }}
                    isInvalid={touched.name && errors.name}
                  />

                  {touched.name && errors.name && (
                    <div className="text-danger">{errors.name}</div>
                  )}
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Phone</Form.Label>
                  <PhoneInput className="w-100"
                    country={"gb"}
                    name="phoneNumber"
                    type="phone"
                    disabled={userToken}
                    enableSearch={true}
                    value={values.phoneNumber ?  `+${values.countryCode}${values.phoneNumber}` :phone}
                     onChange={(phone ,country) => {
                      setPhone(phone)
                      if(phone){
                        setFieldValue("phoneNumber", phone.slice(country.dialCode.length))
                        setFieldValue('countryCode', country.dialCode);
                      }
                    }}
                  />
                   {touched.phoneNumber && errors.phoneNumber && (
                    <div className="text-danger">{errors.phoneNumber}</div>
                  )}
              
                </Form.Group>
               
                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Email</Form.Label>
                  <Form.Control type="email"
                    placeholder="Type here"
                    name="email"
                    disabled={userToken}
                    value={values.email}
                    onChange={(e) => setFieldValue("email", e.target.value)}
                    isInvalid={touched.email && errors.email}
                  />

                  {touched.email && errors.email && (
                    <div className="text-danger">{errors.email}</div>
                  )}
                </Form.Group>
              </Form>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default EnquiryEleven;